import { GlassButton } from "@/components/glass/Glass";
import { IconFilm, IconRefresh, IconWifiSlash } from "@/components/icons/Icons";
import { Reveal } from "./Reveal";
import { SERVER_DOWN } from "@/services/api";

export function EmptyState({ icon: Icon = IconFilm, title, text, action, testId = "empty-state" }) {
  return (
    <Reveal className="mx-auto flex max-w-md flex-col items-center px-6 py-16 text-center" data-testid={testId}>
      <div className="pk-glass mb-5 grid h-16 w-16 place-items-center rounded-[20px] text-white/80">
        <Icon size={28} />
      </div>
      <h3 className="text-[19px] font-semibold tracking-[-0.01em] text-white">{title}</h3>
      {text && <p className="mt-2 text-[14.5px] leading-relaxed text-white/60">{text}</p>}
      {action && <div className="mt-6">{action}</div>}
    </Reveal>
  );
}

export function ErrorState({ error, onRetry, title, testId = "error-banner" }) {
  const msg = title || error?.message || SERVER_DOWN;
  return (
    <Reveal className="mx-auto flex max-w-md flex-col items-center px-6 py-16 text-center" data-testid={testId} role="alert">
      <div className="pk-glass mb-5 grid h-16 w-16 place-items-center rounded-[20px] text-white/80">
        <IconWifiSlash size={28} />
      </div>
      <h3 className="text-[18px] font-semibold tracking-[-0.01em] text-white">{msg}</h3>
      <p className="mt-2 text-[14px] text-white/55">Internet aloqasini tekshirib, qayta urinib ko‘ring.</p>
      {onRetry && (
        <GlassButton className="mt-6" onClick={onRetry} data-testid="retry-button">
          <IconRefresh size={18} /> Qayta urinish
        </GlassButton>
      )}
    </Reveal>
  );
}
